import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[bnAutoDecimal]',
})
export class BnAutoDecimalDirective {
  private specialChars = ['Tab', 'ArrowRight', 'ArrowLeft', 'Backspace'];

  constructor(private el: ElementRef) {}

  @HostListener('keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    const element = this.el.nativeElement;
    const value = element.value;

    console.log(this.specialChars.indexOf(event.key));
    if (this.specialChars.indexOf(event.key) !== -1) {
      return;
    }

    if (value.indexOf('.') === -1) {
      element.value = value + '.00';
      element.setSelectionRange(value.length, value.length);
    } else {
      const decimalsPosition = value.indexOf('.') + 1;
      if (element.selectionStart === decimalsPosition + 1) {
        const newString = this.setCharAt(value, element.selectionStart, event.key);
        element.value = newString;
        element.setSelectionRange(decimalsPosition + 1, decimalsPosition + 1);
        event.preventDefault();
        return;
      } else if (element.selectionStart === decimalsPosition + 2) {
        const newString = this.setCharAt(value, decimalsPosition + 2, event.key);
        element.value = newString;
        element.setSelectionRange(decimalsPosition + 2, decimalsPosition + 2);
        event.preventDefault();
        return;
      } else if (element.selectionStart > decimalsPosition + 2) {
        return;
      }
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const element = this.el.nativeElement;
    const value = element.value;
    const decimalsPosition = value.indexOf('.') + 1;

    if (element.selectionStart > decimalsPosition + 1 && this.specialChars.indexOf(event.key) === -1) {
      event.preventDefault();
      return;
    }

    if (isNaN(+event.key) && this.specialChars.indexOf(event.key) === -1 && event.key !== '.') {
      event.preventDefault();
      return;
    }

    if (event.key === '.' && value.indexOf('.') !== -1) {
      element.setSelectionRange(decimalsPosition, decimalsPosition);
      event.preventDefault();
      return;
    }
  }

  setCharAt(str: string, index: number, chr: string) {
    if (index > str.length - 1) return str;
    return str.substring(0, index - 1) + chr + str.substring(index + 1);
  }
}
